export const typesKeyNames = {
    // 1: 'passbook',
    //3: 'old_roll',
    5: 'counterfoil',
    6: 'roll',
    7: 'stickers',
    8: 'evolis',
    //9: 'counterfoil_us',
    11: 'pdf'
    // Merged Badge types 12 and 11 in the type 11
    // 13: 'generic_zpl'
};

export const groupTypes = {
    // passbook: [1],
    pdf: [11],
    thermal: [5, 6, 7, 8]
};
